import React from 'react';

import SecondCopyModal, {
  DocumentFormat,
} from 'pages/shared/components/SecondCopyModal';

const isValidEmail = (value: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

export { isValidEmail };

export type EmailModalProps = {
  open: boolean;
  email: string;
  invoiceNumber?: string | number;
  itemCount?: number;
  totalAmount: string;
  loading?: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onEmailChange: (value: string) => void;
  format?: DocumentFormat;
  onFormatChange?: (format: DocumentFormat) => void;
};

const EmailModal = ({
  open,
  email,
  invoiceNumber,
  itemCount = 1,
  totalAmount,
  loading = false,
  onClose,
  onSubmit,
  onEmailChange,
  format = 'PDF',
  onFormatChange,
}: EmailModalProps): JSX.Element => {
  const description =
    itemCount === 1 ? (
      <>
        Será enviada a 2ª via da{' '}
        <strong>Nota fiscal {invoiceNumber ?? '-'}</strong> para o e-mail
        informado.
      </>
    ) : (
      <>
        Serão enviadas as 2ª vias das{' '}
        <strong>{itemCount} notas fiscais selecionadas</strong> para o e-mail
        informado.
      </>
    );

  return (
    <SecondCopyModal
      open={open}
      mode="email"
      email={email}
      itemCount={itemCount}
      totalAmount={totalAmount}
      format={format}
      onFormatChange={onFormatChange ?? (() => undefined)}
      loading={loading}
      submitDisabled={!isValidEmail(email)}
      onClose={onClose}
      onSubmit={onSubmit}
      onEmailChange={onEmailChange}
      itemLabelSingular="nota fiscal"
      itemLabelPlural="notas fiscais"
      description={description}
    />
  );
};

export default EmailModal;
